"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _usePDFPage2 = require("../../hooks/usePDFPage/usePDFPage");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StudioPDFPage = function StudioPDFPage(_ref) {
  var url = _ref.url,
    pageNumber = _ref.pageNumber,
    height = _ref.height,
    width = _ref.width,
    onRenderSuccess = _ref.onRenderSuccess,
    className = _ref.className,
    documentCache = _ref.documentCache,
    loading = _ref.loading,
    error = _ref.error;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var hasMountedRef = (0, _react.useRef)(false);
  var _usePDFPage = (0, _usePDFPage2.usePDFPage)(url, pageNumber, {
      maxWidth: width,
      maxHeight: height,
      onError: function onError() {
        return setHasError(true);
      },
      documentCache: documentCache
    }),
    imageUrl = _usePDFPage.imageUrl,
    dimensions = _usePDFPage.dimensions;
  (0, _react.useEffect)(function () {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    setHasError(false);
  }, [url, pageNumber]);
  (0, _react.useEffect)(function () {
    if (imageUrl) {
      onRenderSuccess === null || onRenderSuccess === void 0 || onRenderSuccess({
        pageNumber: pageNumber,
        width: dimensions.width,
        height: dimensions.height
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageUrl]);
  if (!pageNumber) return null;
  if (hasError) {
    return error || loading || null;
  }
  if (!imageUrl) {
    return loading || /*#__PURE__*/_react["default"].createElement("div", {
      className: className,
      style: {
        width: width,
        height: height,
        background: '#dfe3ec'
      },
      "data-testid": "pdf-page-loading"
    });
  }
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: className,
    src: imageUrl,
    width: dimensions.width,
    height: dimensions.height,
    alt: "",
    "data-page-number": pageNumber,
    "data-testid": "pdf-page"
  });
};
StudioPDFPage.propTypes = {
  url: _propTypes["default"].string.isRequired,
  pageNumber: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number,
  width: _propTypes["default"].number,
  onRenderSuccess: _propTypes["default"].func,
  className: _propTypes["default"].string,
  documentCache: _propTypes["default"].object,
  loading: _propTypes["default"].node,
  error: _propTypes["default"].node
};
var _default = exports["default"] = StudioPDFPage;